var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 34,
    viewBox: "0 0 89 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6306_70048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50961 9.39246C6.42246 8.79455 6.54889 8.49737 6.42951 7.23511C7.04016 8.34709 7.31137 8.52146 8.4032 8.50454C7.49035 9.10245 7.36392 9.39963 7.4833 10.6619C6.87265 9.54991 6.60144 9.37555 5.50961 9.39246Z",
    fill: "url(#paint0_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.999 4.53583C9.63115 4.15347 9.72479 3.97271 9.68019 3.2236C10.0601 3.86917 10.2379 3.96542 10.9742 3.92433C10.342 4.3067 10.2484 4.48745 10.293 5.23656C9.91308 4.59099 9.73526 4.49474 8.999 4.53583Z",
    fill: "url(#paint1_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6864 5.57126C14.9507 4.80654 15.138 4.44503 15.0488 2.94681C15.8087 4.23795 16.1643 4.43044 17.6368 4.34827C16.3725 5.11299 16.1852 5.4745 16.2744 6.97272C15.5146 5.68158 15.1589 5.48909 13.6864 5.57126Z",
    fill: "url(#paint2_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5696 7.17863C12.2043 6.76792 13.0498 6.95651 13.4584 7.59998C13.8671 8.24344 13.6839 9.09764 13.0492 9.50835C12.4144 9.91906 11.569 9.73047 11.1603 9.08701C10.7517 8.44354 10.9352 7.5891 11.5696 7.17863ZM23.7669 26.3845C25.9067 24.9999 28.4613 24.8555 30.5282 25.7809C28.7552 26.3535 26.8864 27.2369 25.0591 28.4193C23.2318 29.6016 21.6562 30.9465 20.4007 32.334C20.4301 30.0522 21.6271 27.7691 23.7669 26.3845ZM10.8411 27.5746C10.8411 27.5746 9.00594 29.8426 6.22097 30.0793C3.436 30.3159 1.16287 25.9663 3.59763 23.9571C6.03225 21.9486 11.2933 28.8596 19.1627 26.8808C31.4226 23.7984 26.6551 3.27557 37.1202 1.87001C34.5864 0.960744 32.7568 1.5227 31.2987 2.72984C25.3355 7.66639 25.9243 17.8605 19.1751 21.8614C12.9744 25.5366 7.57275 21.2856 3.56822 22.3587C-0.436549 23.4313 -0.549322 30.6786 3.54018 32.4969C7.63029 34.3154 10.8411 27.5746 10.8411 27.5746ZM22.327 9.08097C11.9552 11.493 10.6208 15.8827 11.2084 17.6031C11.7962 19.323 14.3157 19.4138 16.4381 18.1554C18.5607 16.8972 21.6145 14.8596 20.8644 13.6249C20.1143 12.3901 13.2534 16.1476 13.2534 16.1476C17.3386 11.5614 23.2807 9.68854 23.8833 11.6752C24.2251 12.802 23.0363 17.3155 18.1248 20.2267C13.2137 23.1376 9.21445 21.5267 8.26795 20.0363C7.32145 18.5459 7.45222 14.0606 12.9985 10.7727C18.545 7.48518 22.327 9.08097 22.327 9.08097Z",
    fill: "url(#paint3_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1978 32.2311C48.9681 32.2311 48.7385 32.2165 48.5088 32.1874C47.5518 32.032 46.7241 31.6678 46.0255 31.0948C45.327 30.5218 44.8054 29.808 44.4609 28.9533C43.6284 29.2155 42.7528 29.3467 41.8342 29.3467C40.0256 29.3467 38.5567 28.8611 37.4275 27.8899C36.3079 26.909 35.748 25.6221 35.748 24.0294C35.748 22.4366 36.3222 21.1595 37.4705 20.198C38.6189 19.2268 40.1308 18.7412 42.0064 18.7412C43.0877 18.7412 44.1404 18.8529 45.1643 19.0763C45.6236 19.1734 45.9968 19.2802 46.2839 19.3968L46.1404 22.1938H46.0112C45.7815 21.2809 45.327 20.601 44.6475 20.1543C43.9777 19.6978 43.1643 19.4696 42.2074 19.4696C41.2504 19.4696 40.461 19.8969 39.8389 20.7516C39.2169 21.6062 38.9059 22.7328 38.9059 24.1313C38.9059 25.0151 39.0399 25.7969 39.3078 26.4768C39.5758 27.1566 39.9586 27.6859 40.4562 28.0647C40.9538 28.4337 41.504 28.6183 42.1069 28.6183C42.7193 28.6183 43.1978 28.4774 43.5423 28.1958C43.8964 27.9044 44.0734 27.5257 44.0734 27.0595V25.0783C44.083 24.8646 44.0208 24.6995 43.8868 24.5829C43.7624 24.4664 43.5806 24.4081 43.3413 24.4081H43.126V24.2625H47.949V24.4081H47.7193C47.4896 24.4081 47.3126 24.4664 47.1882 24.5829C47.0638 24.6995 47.0064 24.8646 47.016 25.0783V27.4383C47.016 28.0016 47.126 28.56 47.3461 29.1136C47.8437 30.3373 48.638 31.124 49.7289 31.4736C50.0447 31.5707 50.3605 31.6193 50.6763 31.6193C50.992 31.6193 51.303 31.5853 51.6093 31.5173L51.638 31.663C50.7767 32.0417 49.9633 32.2311 49.1978 32.2311Z",
    fill: "url(#paint4_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7395 28.997C48.9883 28.997 49.1988 28.9096 49.371 28.7348C49.5529 28.5503 49.6486 28.3318 49.6581 28.0793V20.0086C49.6486 19.6978 49.5194 19.4502 49.2706 19.2656C49.1175 19.1491 48.9404 19.0908 48.7395 19.0908H48.5529V18.9452H53.3328C53.7442 18.9452 54.1079 18.9112 54.4237 18.8432C54.749 18.7752 54.9548 18.7218 55.0409 18.6829V21.6839H54.8973V21.5674C54.8973 20.9944 54.7395 20.5428 54.4237 20.2126C54.1079 19.8824 53.6677 19.7075 53.1031 19.6881H52.6007V23.7526H54.5959C55.0552 23.7429 55.4284 23.5923 55.7155 23.301C56.0026 22.9999 56.1461 22.6163 56.1461 22.1501V22.0918H56.2897V26.1417H56.1461V26.0689C56.1461 25.6124 56.0026 25.2385 55.7155 24.9471C55.4284 24.6461 55.06 24.4907 54.6103 24.481H52.6007V28.3997H55.2275C55.926 28.3997 56.5433 28.1667 57.0792 27.7005C57.615 27.2343 57.993 26.5885 58.2131 25.7629H58.3567L57.8112 29.1427H48.5529V28.997H48.7395Z",
    fill: "url(#paint5_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7334 31.1094C74.1497 31.4784 73.5181 31.663 72.8387 31.663C72.2454 31.663 71.6281 31.4833 70.987 31.124C70.3267 30.7646 69.6808 30.2547 69.0492 29.5943L62.7478 22.9805V28.1084C62.7478 28.3609 62.8339 28.5746 63.0061 28.7494C63.1784 28.9145 63.3841 28.997 63.6234 28.997H63.8961V29.1427H58.6425V28.997H58.9152C59.1545 28.997 59.3602 28.9145 59.5325 28.7494C59.7047 28.5746 59.7908 28.3609 59.7908 28.1084V19.8629C58.3172 18.2702 57.0253 17.4738 55.9152 17.4738C55.6377 17.4738 55.3698 17.5223 55.1114 17.6195L55.0396 17.4884C55.5755 17.0999 56.1545 16.9056 56.7765 16.9056C57.188 16.9056 57.609 16.9882 58.0396 17.1533C58.4607 17.3087 58.8291 17.4884 59.1449 17.6923C59.7382 18.0905 60.2645 18.5275 60.7238 19.0034L66.6234 25.1948V19.9795C66.6138 19.727 66.5229 19.5182 66.3506 19.3531C66.1784 19.1782 65.9726 19.0908 65.7334 19.0908H65.4607V18.9452H70.7143V19.0908H70.4559C70.2167 19.0908 70.0109 19.1782 69.8387 19.3531C69.6664 19.5182 69.5755 19.7221 69.5659 19.9649V28.2832L69.8243 28.56C69.8243 28.56 69.9344 28.6814 70.1545 28.9242C70.3841 29.167 70.5372 29.3272 70.6138 29.4049C70.6999 29.4826 70.8674 29.6332 71.1162 29.8565C71.365 30.0896 71.5659 30.2499 71.719 30.3373C71.8722 30.4344 72.0827 30.5558 72.3506 30.7015C72.6186 30.8569 72.8626 30.954 73.0827 30.9928C73.3315 31.0511 73.5946 31.0802 73.8722 31.0802C74.1497 31.0802 74.4176 31.0414 74.676 30.9637L74.7334 31.1094Z",
    fill: "url(#paint6_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5448 28.997H77.7314V29.1427H72.5783V28.997H72.7649C73.0137 28.997 73.2242 28.9096 73.3964 28.7348C73.5783 28.5503 73.674 28.3318 73.6835 28.0793V19.6735L72.4347 19.7173C71.6309 19.7464 71.2003 20.0475 71.1429 20.6205C71.1429 20.6496 71.1429 20.6787 71.1429 20.7079C71.1429 20.9798 71.2338 21.1983 71.4156 21.3634C71.5974 21.5285 71.8271 21.6111 72.1046 21.6111C72.162 21.6111 72.2194 21.6111 72.2768 21.6111V21.6985C72.0663 21.815 71.8558 21.8733 71.6453 21.8733C71.4443 21.8733 71.2386 21.8102 71.028 21.6839C70.6261 21.4411 70.4252 21.0818 70.4252 20.6059C70.4252 20.1591 70.5974 19.7901 70.9419 19.4987C71.2864 19.1977 71.8271 19.0326 72.5639 19.0034C72.6692 18.9937 73.0041 18.9791 73.5687 18.9597C74.1429 18.9403 74.6357 18.9257 75.0472 18.916C76.2338 18.8577 77.1285 18.7703 77.7314 18.6538L77.7601 18.7995C77.2242 18.8869 76.8845 19.12 76.7409 19.4987C76.674 19.6833 76.6357 19.9163 76.6261 20.198V28.0793C76.6261 28.3318 76.717 28.5503 76.8988 28.7348C77.0806 28.9096 77.296 28.997 77.5448 28.997Z",
    fill: "url(#paint7_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7512 28.997C79 28.997 79.2105 28.9096 79.3828 28.7348C79.5646 28.5503 79.6603 28.3318 79.6698 28.0793V20.0086C79.6603 19.6978 79.5311 19.4502 79.2823 19.2656C79.1292 19.1491 78.9521 19.0908 78.7512 19.0908H78.5646V18.9452H83.3445C83.756 18.9452 84.1196 18.9112 84.4354 18.8432C84.7607 18.7752 84.9665 18.7218 85.0526 18.6829V21.6839H84.9091V21.5674C84.9091 20.9944 84.7512 20.5428 84.4354 20.2126C84.1196 19.8824 83.6794 19.7075 83.1148 19.6881H82.6124V23.7526H84.6076C85.067 23.7429 85.4402 23.5923 85.7272 23.301C86.0143 22.9999 86.1579 22.6163 86.1579 22.1501V22.0918H86.3014V26.1417H86.1579V26.0689C86.1579 25.6124 86.0143 25.2385 85.7272 24.9471C85.4402 24.6461 85.0717 24.4907 84.622 24.481H82.6124V28.3997H85.2392C85.9378 28.3997 86.555 28.1667 87.0909 27.7005C87.6268 27.2343 88.0048 26.5885 88.2248 25.7629H88.3684L87.8229 29.1427H78.5646V28.997H78.7512Z",
    fill: "url(#paint8_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8536 6.32626C36.8442 5.79706 36.5701 5.53246 36.0315 5.53246C35.9843 5.53246 35.8992 5.53703 35.7764 5.54615L35.748 5.42298C36.5418 5.36823 37.5009 5.24962 38.6254 5.06714C39.7499 4.88465 40.4539 4.77973 40.7373 4.75235C41.0303 4.72498 41.2996 4.7113 41.5453 4.7113C42.3012 4.7113 42.8965 4.77973 43.3312 4.91659C43.7753 5.04433 44.1628 5.21312 44.4935 5.42298C44.8242 5.63283 45.0888 5.92024 45.2872 6.2852C45.5046 6.68666 45.6132 7.11549 45.6132 7.5717C45.6132 8.01878 45.5518 8.41567 45.429 8.76239C45.3061 9.10911 45.1313 9.40564 44.9045 9.65199C44.2242 10.4002 43.3548 10.7743 42.2965 10.7743C41.928 10.7743 41.5925 10.7195 41.2901 10.61C40.7326 10.4093 40.3735 10.0534 40.2129 9.5425L40.3546 9.46038C40.4869 9.64286 40.7043 9.73411 41.0067 9.73411C41.4697 9.73411 41.8807 9.46951 42.2398 8.94031C42.4571 8.60272 42.5658 8.15564 42.5658 7.59907C42.5658 6.82352 42.3626 6.2487 41.9563 5.87462C41.6539 5.59177 41.2712 5.45035 40.8082 5.45035C40.6948 5.45035 40.5767 5.45947 40.4539 5.47772L39.7593 5.57352V13.5388C39.7688 13.7761 39.8585 13.9814 40.0286 14.1547C40.2082 14.319 40.4208 14.4011 40.6665 14.4011H40.8507V14.5379H35.7622V14.4011H35.9465C36.1922 14.4011 36.4001 14.319 36.5701 14.1547C36.7497 13.9814 36.8442 13.7761 36.8536 13.5388V6.32626Z",
    fill: "url(#paint9_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2171 1.90564C59.3494 1.90564 59.4817 1.91476 59.614 1.93301V2.06987C58.7635 2.17024 58.121 2.55801 57.6863 3.23319C57.2516 3.90838 57.0343 4.80254 57.0343 5.91568V11.0206C57.0154 12.225 56.6138 13.1465 55.8295 13.7852C55.0546 14.4148 53.9018 14.7295 52.371 14.7295C50.8402 14.7295 49.6354 14.4011 48.7566 13.7441C47.8778 13.0872 47.4384 12.2113 47.4384 11.1164C47.4384 11.089 47.4384 11.0617 47.4384 11.0343V5.76513C47.4384 5.57352 47.3628 5.41385 47.2116 5.28611C47.0699 5.15838 46.895 5.09451 46.6872 5.09451H46.4604V4.95765H51.3221V5.09451H51.0953C50.8024 5.09451 50.585 5.204 50.4433 5.42298C50.3866 5.52334 50.3535 5.62827 50.3441 5.73776V10.9795C50.3441 11.9284 50.5898 12.6766 51.0811 13.2241C51.582 13.7624 52.2434 14.0316 53.0655 14.0316C53.075 14.0316 53.0797 14.0316 53.0797 14.0316C53.0891 14.0316 53.0986 14.0316 53.108 14.0316C53.8923 14.0316 54.5349 13.7806 55.0357 13.2788C55.546 12.7679 55.8011 12.0607 55.8011 11.1575V5.91568C55.8011 4.78429 56.1413 3.81257 56.8217 3.00053C57.1429 2.62644 57.5162 2.35272 57.9414 2.17936C58.3761 1.99688 58.8013 1.90564 59.2171 1.90564Z",
    fill: "url(#paint10_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9323 16.3856C73.3559 16.7323 72.7322 16.9056 72.0613 16.9056C71.4754 16.9056 70.8659 16.7368 70.2328 16.3993C69.5808 16.0617 68.943 15.5826 68.3193 14.9622L62.0969 8.74871V13.5662C62.0969 13.8035 62.1819 14.0042 62.352 14.1684C62.5221 14.3235 62.7253 14.4011 62.9615 14.4011H63.2308V14.5379H58.0431V14.4011H58.3124C58.5486 14.4011 58.7518 14.3235 58.9219 14.1684C59.092 14.0042 59.177 13.8035 59.177 13.5662V5.81988C57.7218 4.32352 56.4461 3.57535 55.35 3.57535C55.076 3.57535 54.8114 3.62097 54.5562 3.71221L54.4854 3.58904C55.0145 3.22407 55.5862 3.04159 56.2004 3.04159C56.6068 3.04159 57.0225 3.11915 57.4478 3.27426C57.8635 3.42024 58.2273 3.58904 58.5392 3.78064C59.125 4.15473 59.6448 4.56531 60.0983 5.01239L65.9239 10.829V5.92936C65.9144 5.69214 65.8247 5.49597 65.6546 5.34086C65.4845 5.17663 65.2813 5.09451 65.0451 5.09451H64.7758V4.95765H69.9635V5.09451H69.7084C69.4722 5.09451 69.269 5.17663 69.0989 5.34086C68.9288 5.49597 68.839 5.68758 68.8296 5.91568V13.7305L69.0847 13.9905C69.0847 13.9905 69.1934 14.1045 69.4107 14.3326C69.6375 14.5608 69.7887 14.7113 69.8643 14.7843C69.9493 14.8573 70.1147 14.9987 70.3604 15.2086C70.6061 15.4275 70.8045 15.5781 70.9557 15.6602C71.1069 15.7514 71.3148 15.8655 71.5794 16.0024C71.844 16.1483 72.0849 16.2396 72.3023 16.2761C72.5479 16.3308 72.8078 16.3582 73.0818 16.3582C73.3559 16.3582 73.6204 16.3217 73.8756 16.2487L73.9323 16.3856Z",
    fill: "url(#paint11_linear_6306_70048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1883 8.4613C69.6119 7.9686 69.3237 7.4394 69.3237 6.87371C69.3237 6.34451 69.5458 5.89743 69.9899 5.53247C70.4623 5.14013 71.0766 4.94396 71.8325 4.94396H79.0755C79.3684 4.94396 79.685 4.91659 80.0252 4.86185C80.3653 4.8071 80.6063 4.75236 80.748 4.69761V7.51695L80.6063 7.50327V7.40747C80.6063 6.66841 80.3228 6.14834 79.7559 5.84725C79.4818 5.71039 79.1558 5.63739 78.7778 5.62827H77.3888V13.5525C77.3982 13.7898 77.488 13.9905 77.6581 14.1547C77.8376 14.319 78.0502 14.4011 78.2959 14.4011H78.4802V14.5379H73.3917V14.4011H73.5759C73.8216 14.4011 74.0295 14.319 74.1996 14.1547C74.3791 13.9905 74.4736 13.7943 74.4831 13.5662V5.62827H71.8325C71.3033 5.62827 70.8639 5.75144 70.5143 5.99779C70.108 6.28064 69.9048 6.63648 69.9048 7.06531C69.9048 7.48502 70.0513 7.92754 70.3442 8.39287L70.1883 8.4613Z",
    fill: "url(#paint12_linear_6306_70048)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6306_70048",
    x: 0,
    y: 0,
    width: 89,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_6306_70048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6306_70048",
    x1: 14.439,
    y1: 1.6705,
    x2: 24.057,
    y2: 31.1407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6306_70048",
    x1: 14.439,
    y1: 1.6705,
    x2: 24.057,
    y2: 31.1407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6306_70048",
    x1: 14.439,
    y1: 1.6705,
    x2: 24.057,
    y2: 31.1407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6306_70048",
    x1: 14.439,
    y1: 1.6705,
    x2: 24.057,
    y2: 31.1407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6306_70048",
    x1: 62.0582,
    y1: 16.9056,
    x2: 62.0582,
    y2: 32.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6306_70048",
    x1: 62.0582,
    y1: 16.9056,
    x2: 62.0582,
    y2: 32.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6306_70048",
    x1: 62.0582,
    y1: 16.9056,
    x2: 62.0582,
    y2: 32.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6306_70048",
    x1: 62.0582,
    y1: 16.9056,
    x2: 62.0582,
    y2: 32.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6306_70048",
    x1: 62.0582,
    y1: 16.9056,
    x2: 62.0582,
    y2: 32.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6306_70048",
    x1: 58.248,
    y1: 1.90564,
    x2: 58.248,
    y2: 16.9056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6306_70048",
    x1: 58.248,
    y1: 1.90564,
    x2: 58.248,
    y2: 16.9056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6306_70048",
    x1: 58.248,
    y1: 1.90564,
    x2: 58.248,
    y2: 16.9056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6306_70048",
    x1: 58.248,
    y1: 1.90564,
    x2: 58.248,
    y2: 16.9056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default ForwardRef;